import isBrowserContext from "helpers/isBrowserContext";
import { useEffect, useState } from "react";

export default (scrollType: string, styles: any) => {
    const [viewState, setViewState] = useState<string | undefined>(undefined);
    const threshold = 100;

    useEffect(() => {
        let previousScrollPosition = isBrowserContext() ? window.pageYOffset : 0;

        const scrollHandler = () => {
            const currentScrollPosition = window.pageYOffset;

            if (currentScrollPosition > threshold) {
                if (previousScrollPosition > currentScrollPosition) {
                    // Scrolling up
                    setViewState(undefined);
                }
                else {
                    // Scrolling down
                    setViewState(styles[`scroll_type_${scrollType}`]);
                }

                previousScrollPosition = currentScrollPosition;
            }
            else {
                // Under threshold
                setViewState(undefined);
            }
        };

        if (isBrowserContext()) {
            window.addEventListener("scroll", scrollHandler);
        }

        return () => {
            if (isBrowserContext()) {
                window.removeEventListener("scroll", scrollHandler);
            }
        };
    }, [setViewState]);

    return viewState;
};